<template>
  <div>
    <el-dialog
      title="确定核销?"
      :visible.sync="visible" width="650px"
      :before-close="cancel"
      v-loading="loading">
      <el-form>
        <el-form-item label="收付金额">
          {{pay_info.pay_total}}
        </el-form-item>
        <el-form-item label="缴费时间">
          <span style="color:red">{{pay_info.date}}</span>
        </el-form-item>
        <el-form-item label="同时开发票">
          <el-select v-model="invoice_select" @change="handleInvoiceSelect">
            <el-option label="是" :value="true"></el-option>
            <el-option label="否" :value="false"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开票信息" v-if="invoice_select">
          <el-descriptions v-if="invoice_select && invoiceForm.move_type === 1" title="" :column="2" border>
            <el-descriptions-item label="操作类型">
              <span >开具发票</span>
            </el-descriptions-item>
            <el-descriptions-item label="发票类型">
              <span v-if="invoiceForm.invoice_type == '82'">电子普票</span>
              <span v-else>电子专票</span>
            </el-descriptions-item>
            <el-descriptions-item label="发票抬头">
              {{invoiceForm.title}}
            </el-descriptions-item>
            <el-descriptions-item label="纳税人识别号">
              {{invoiceForm.taxNo}}
            </el-descriptions-item>
            <el-descriptions-item label="是否不动产">
              <span v-if="invoiceForm.taxAddressType === 0">否</span>
              <span v-else>是</span>
            </el-descriptions-item>
            <el-descriptions-item v-if="invoiceForm.taxAddressType === 1" label="不动产所在省市">
              {{invoiceForm.realEstatePlace}}
            </el-descriptions-item>
            <el-descriptions-item v-if="invoiceForm.taxAddressType === 1" label="不动产详细地址">
              {{invoiceForm.fullAddress}}
            </el-descriptions-item>
            <el-descriptions-item label="购方地址">
              {{invoiceForm.address}}
            </el-descriptions-item>
            <el-descriptions-item label="开户行">
              {{invoiceForm.bank}}
            </el-descriptions-item>
            <el-descriptions-item label="银行账号">
              {{invoiceForm.bankAccount}}
            </el-descriptions-item>
            <el-descriptions-item label="电话">
              {{invoiceForm.phone}}
            </el-descriptions-item>
            <el-descriptions-item label="邮箱">
              {{invoiceForm.email}}
            </el-descriptions-item>
            <el-descriptions-item label="备注">
              {{invoiceForm.remark}}
            </el-descriptions-item>
          </el-descriptions>
          <el-descriptions v-if="invoice_select && invoiceForm.move_type === 2" title="" :column="2" border>
            <el-descriptions-item label="操作类型">
              <span >补录发票</span>
            </el-descriptions-item>
            <el-descriptions-item label="发票类型">
              <span v-if="invoiceForm.invoice_type == '82'">电子普票</span>
              <span v-else>电子专票</span>
            </el-descriptions-item>
            <el-descriptions-item label="发票号">
              {{invoiceForm.invoice_no}}
            </el-descriptions-item>
            <el-descriptions-item label="开票前金额">
              {{invoiceForm.invoice_total}}
            </el-descriptions-item>
            <el-descriptions-item label="开票金额">
              {{invoiceForm.tax_total}}
            </el-descriptions-item>
            <el-descriptions-item label="开票日期">
              {{invoiceForm.invoice_date}}
            </el-descriptions-item>
          </el-descriptions>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="sendMoneyPay">确认收付</el-button>
          <el-button @click="cancel">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <electronic-invoice-form :order_type="'paid_order'" ref="moneyPay_invoiceFormRef"
                             @close="handleCloseInvoice" :send_method="false"
                             @sendInvoice="handleInvoiceInput">
    </electronic-invoice-form>
  </div>
</template>

<script>
import ElectronicInvoiceForm from "@/components/Admin/Order/order/electronicInvoiceForm.vue";

export default {
  name: 'moneyPay',
  data() {
    return {
      loading : false,
      invoice_select : false,
      invoiceForm : {}
    }
  },
  props : {
    visible : {
       type : Boolean , default : false
    },
    pay_info : {
      type : Object , default : {}
    }
  },
  watch: {
    visible(val){
      if(!val){
        this.invoice_select = false;
        this.invoiceForm = {};
      }
    }
  },
  methods: {
    handleInvoiceInput(invoiceForm){
      this.invoice_select = true;
      this.invoiceForm = invoiceForm;
    },
    handleInvoiceSelect(val){
      if(this.invoice_select){
        this.$refs.moneyPay_invoiceFormRef.openInvoiceForm(this.pay_info.pid , this.pay_info.order)
      }
    },
    handleCloseInvoice(){
      this.invoice_select = false;
      this.invoiceForm = {};
    },
    sendInvoice(detailIds){
      // 转数组
      let orderDetailIds = detailIds.split(',');
      this.invoiceForm.orderDetailIds = orderDetailIds;
      this.invoiceForm.order_type = 'paid_order';
      this.$myhttp
        .post('admin/Invoice/issueInvoice', this.invoiceForm, {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.$message.success(backdata.data.msg);
            this.loading = false;
          } else {
            this.$message.error(backdata.data.msg + "\n 核销成功，但是开票失败，可以前往电子发票页面继续开票！");
            this.loading = false;
          }
          this.$emit('pay_finish' , detailIds);
        })
        .catch((err) => {
          this.$message.error(err + "\n 核销成功，但是开票失败，可以前往电子发票页面继续开票");
          this.loading = false;
        });
    },
    sendMoneyPay(){
      this.loading = true;
        this.$myhttp.post('admin/OrderList/money_pay' , this.pay_info , {
          'Content-Type': 'application/x-www-form-urlencoded'
          }).then(backdata=>{ // 异步执行成功后
            if(backdata.data.code == 201){
              this.loading = false;
              this.$confirm(''+backdata.data.message, '提示', {
                confirmButtonText: '关闭',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => { })
            }else{
              let order_detail_ids = backdata.data.detail_id;
              if(this.invoice_select){
                // 继续开票
                this.$Message.success('核销成功，正在开票');
                this.sendInvoice(order_detail_ids);
              }else{
                this.$Message.success(backdata.data.message);
                this.loading = false;
                this.$emit('pay_finish' , order_detail_ids);
              }
            }
        },err=>{
          this.$Message.error('请求超时!');
        });
    },
    cancel(){
      this.visible = false;
      this.$emit('close');
    },
  },
  components : {
    ElectronicInvoiceForm : ElectronicInvoiceForm
  }
}
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/order/moneyPay.vue